/* eslint-disable */
import numeral from 'numeral'

// 注册“万”作为缩写
numeral.register('format', '万', {
  regexps: {
    format: /万/,
    unformat: /万/
  },
  format: (value, format, roundingFunction) => {
    const [numFormat, str] = format.split(' ')
    const newValue = value / 10000
    return numeral._.numberToFormat(newValue, numFormat, roundingFunction) + '万'
  },
  unformat: (string) => {
    const value = numeral._.stringToNumber(string) || 0
    return value * 10000
  }
})

// 注册中文语言环境
numeral.register('locale', 'zh-cn', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: '千',
    million: '百万',
    billion: '十亿',
    trillion: '兆'
  },
  ordinal: (number) => {
    return number === 1 ? '第一' : '第' + numeral(number).format('0o')
  },
  currency: {
    symbol: '¥'
  }
})

// 将语言环境设置为中文（中国）
// numeral.locale('zh-cn')

export default numeral
